module.exports = __webpack_public_path__ + "static/media/choithramsOreoBrand.9e89b3ba.jpg";